import request from '@/utils/request'
import { stripEmpty, toFormData } from './utils/payload'

const BASE = '/inquiries/location'

const local = {
  localErrorHandling: true,
}

function unwrapData(payload) {
  if (payload && typeof payload === 'object' && Object.prototype.hasOwnProperty.call(payload, 'data') && ('success' in payload || 'message' in payload)) {
    return payload.data
  }
  return payload
}

const LocationInquiryApi = {
  options() {
    return request({
      url: `${BASE}/options`,
      method: 'get',
      ...local,
    }).then(unwrapData)
  },

  template(system) {
    return request({
      url: `${BASE}/template`,
      method: 'get',
      params: { system },
      responseType: 'blob',
      rawResponse: true,
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/octet-stream, application/json;q=0.1',
      },
      ...local,
    })
  },

  inquire(body, onUploadProgress) {
    if (body && body.file) {
      return request({
        url: BASE,
        method: 'post',
        data: toFormData(body),
        onUploadProgress,
        ...local,
      }).then(unwrapData)
    }
    return request({
      url: BASE,
      method: 'post',
      data: stripEmpty(body),
      ...local,
    }).then(unwrapData)
  },
}

export { LocationInquiryApi }
export default LocationInquiryApi
